// import Vue from 'vue'
// import Vuex from 'vuex'
import store from '../store'
import { setToken, setUserId, setUserPageCode, setLeaderFlag, setUserAccount, setUserAreaCode, setUserAreaFlag, setUserLevel, setUserOrg, setModuleInfo } from '@/utils/auth'
// 安卓传值
export function popData () {
  let title = document.title
  // let title = '新单保费'
  let posturl = window.location.href.slice(window.location.href.indexOf('#'))
  let andpostData = {
    'careId': store.state.user.pageCode,
    'careTitle': title,
    'careDesc': '整体-' + title,
    'careUrl': posturl
  }
  return JSON.stringify(andpostData)
}

//  ios传值方法
//  eslint-disable-next-line camelcase
export function popData_iOS () {
  let obj = postDataToMobile()
  window.webkit.messageHandlers.passPragma_iOS.postMessage(obj)
}
//  ios传值方法
//  eslint-disable-next-line camelcase
export function popDataShare_iOS () {
  let obj = postDataToMobile()
  window.webkit.messageHandlers.passPragmaShare_iOS.postMessage(obj)
}
//  ios传值方法
//  eslint-disable-next-line camelcase
export function popDataIsCare_iOS () {
  let obj = postDataToMobile()
  window.webkit.messageHandlers.passPragmaIsCare_iOS.postMessage(obj)
}
// 重复登录
// eslint-disable-next-line camelcase
export function login_iOS () {
  let obj = postDataToMobile()
  window.webkit.messageHandlers.loginPragma_iOS.postMessage(obj)
}
// 更改指标、渠道、url时传输数据给mobile 封装传给ios Android的参数
export function postDataToMobile () {
  let title = document.title
  let careTitle
  let careUrl = window.location.href.slice(window.location.href.indexOf('#'))
  let code = store.state.user.pageCode
  var careDesc
  var careId
  var pathId
  var businessId
  var carePath
  let modulesCode = code
  var sharePath
  // 对进入的模块进行判断
  switch (code) {
    // 当进入整体时
    case '01':
      if (store.state.entirety.pageFlag === 1) {
        careTitle = '整体' + '-' + store.state.entirety.typeName + '-' + store.state.entirety.kindName
        careDesc = '条件：' + store.state.entirety.channelName + '-' + store.state.entirety.quotaName
        carePath = '整体' + '-' + store.state.entirety.typeName + '-' + store.state.entirety.kindName + '-' + store.state.entirety.quotaName
        sharePath = '整体' + '-' + store.state.entirety.typeName + '-' + store.state.entirety.kindName + '-' + store.state.entirety.quotaName
      } else {
        if (store.state.entirety.descTitle !== '') {
          careTitle = store.state.entirety.descTitle + '-' + store.state.entirety.quotaName
          careDesc = '条件：' + store.state.entirety.channelName + '-' + store.state.entirety.timeName
          carePath = store.state.entirety.descTitle + '-' + store.state.entirety.quotaName
          sharePath = '整体' + '-' + store.state.entirety.typeName + '-' + store.state.entirety.kindName + '-' + store.state.entirety.quotaName
        } else {
          careTitle = '整体' + '-' + store.state.entirety.typeName + '-' + store.state.entirety.kindName + '-' + store.state.entirety.quotaName
          careDesc = '条件：' + store.state.entirety.channelName + '-' + store.state.entirety.timeName
          carePath = '整体' + '-' + store.state.entirety.typeName + '-' + store.state.entirety.kindName + '-' + store.state.entirety.quotaName
          if (title === '整体') {
            sharePath = '整体' + '-' + store.state.entirety.typeName + '-' + store.state.entirety.kindName + '-' + store.state.entirety.quotaName
          } else {
            sharePath = '整体' + '-' + store.state.entirety.typeName + '-' + store.state.entirety.kindName + '-' + store.state.entirety.quotaName + '-' + title
          }
        }
      }
      //  判断关注详情参数
      if (store.state.entirety.descTitle !== '') {
        pathId = store.state.entirety.pathId + ',' + store.state.entirety.channel
      } else {
        pathId = store.state.entirety.type + ',' + store.state.entirety.kind + ',' + store.state.entirety.channel
      }
      careId = store.state.entirety.quota
      businessId = store.state.entirety.kind
      break
    //  进入个险时
    case '02':
      if (store.state.per.pageFlag === 1) {
        careTitle = '个险' + '-' + store.state.per.typeName + '-' + store.state.per.kindName
        careDesc = '条件：' + store.state.per.channelName + '-' + store.state.per.quotaName
        carePath = '个险' + '-' + store.state.per.typeName + '-' + store.state.per.kindName + '-' + store.state.per.quotaName
        sharePath = '个险' + '-' + store.state.per.typeName + '-' + store.state.per.kindName + '-' + store.state.per.quotaName
      } else {
        if (localStorage.getItem('careDesc')) {
          careTitle = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          careDesc = '条件：' + store.state.per.channelName + '-' + store.state.per.timeName
          carePath = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          sharePath = '个险' + '-' + store.state.per.typeName + '-' + store.state.per.kindName + '-' + store.state.per.quotaName
        } else {
          careTitle = '个险' + '-' + store.state.per.typeName + '-' + store.state.per.kindName + '-' + store.state.per.quotaName
          careDesc = '条件：' + store.state.per.channelName + '-' + store.state.per.timeName
          carePath = '个险' + '-' + store.state.per.typeName + '-' + store.state.per.kindName + '-' + store.state.per.quotaName
          if (title === '个险') {
            sharePath = '个险' + '-' + store.state.per.typeName + '-' + store.state.per.kindName + '-' + store.state.per.quotaName
          } else {
            sharePath = '个险' + '-' + store.state.per.typeName + '-' + store.state.per.kindName + '-' + store.state.per.quotaName + '-' + title
          }
        }
      }
      //  判断关注详情参数
      if (localStorage.getItem('getPath')) {
        pathId = localStorage.getItem('getPath') + store.state.per.channel
      } else {
        pathId = store.state.per.type + ',' + store.state.per.kind + ',' + store.state.per.channel
      }
      careId = store.state.per.quota
      businessId = store.state.per.kind
      break
    //  进入银代时
    case '03':
      if (store.state.bank.pageFlag === 1) {
        careTitle = '银代' + '-' + store.state.bank.typeName + '-' + store.state.bank.kindName
        careDesc = '条件：' + store.state.bank.channelName + '-' + store.state.bank.quotaName
        carePath = '银代' + '-' + store.state.bank.typeName + '-' + store.state.bank.kindName + '-' + store.state.bank.quotaName
        sharePath = '银代' + '-' + store.state.bank.typeName + '-' + store.state.bank.kindName + '-' + store.state.bank.quotaName
      } else {
        if (localStorage.getItem('careDesc')) {
          careTitle = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          careDesc = '条件：' + store.state.bank.channelName + '-' + store.state.bank.timeName
          carePath = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          sharePath = '银代' + '-' + store.state.bank.typeName + '-' + store.state.bank.kindName + '-' + store.state.bank.quotaName
        } else {
          careTitle = '银代' + '-' + store.state.bank.typeName + '-' + store.state.bank.kindName + '-' + store.state.bank.quotaName
          careDesc = '条件：' + store.state.bank.channelName + '-' + store.state.bank.timeName
          carePath = '银代' + '-' + store.state.bank.typeName + '-' + store.state.bank.kindName + '-' + store.state.bank.quotaName
          if (title === '银代') {
            sharePath = '银代' + '-' + store.state.bank.typeName + '-' + store.state.bank.kindName + '-' + store.state.bank.quotaName
          } else {
            sharePath = '银代' + '-' + store.state.bank.typeName + '-' + store.state.bank.kindName + '-' + store.state.bank.quotaName + '-' + title
          }
        }
      }
      //  判断关注详情参数
      if (localStorage.getItem('getPath')) {
        pathId = localStorage.getItem('getPath') + store.state.bank.channel
      } else {
        pathId = store.state.bank.type + ',' + store.state.bank.kind + ',' + store.state.bank.channel
      }
      careId = store.state.bank.quota
      businessId = store.state.bank.kind
      break
    // 进入团体时
    case '04':
      if (store.state.team.pageFlag === 1) {
        careTitle = '团体' + '-' + store.state.team.kindName
        careDesc = '条件：' + store.state.team.channelName + '-' + store.state.team.quotaName
        carePath = '团体' + '-' + store.state.team.kindName + '-' + store.state.team.quotaName
        sharePath = '团体' + '-' + store.state.team.kindName + '-' + store.state.team.quotaName
      } else {
        if (localStorage.getItem('careDesc')) {
          careTitle = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          careDesc = '条件：' + store.state.team.channelName + '-' + store.state.team.timeName
          carePath = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          sharePath = '团体' + '-' + store.state.team.kindName + '-' + store.state.team.quotaName
        } else {
          careTitle = '团体' + '-' + store.state.team.kindName + '-' + store.state.team.quotaName
          careDesc = '条件：' + store.state.team.channelName + '-' + store.state.team.timeName
          carePath = '团体' + '-' + store.state.team.kindName + '-' + store.state.team.quotaName
          if (title === '团体') {
            sharePath = '团体' + '-' + store.state.team.kindName + '-' + store.state.team.quotaName
          } else {
            sharePath = '团体' + '-' + store.state.team.kindName + '-' + store.state.team.quotaName + '-' + title
          }
        }
      }
      //  判断关注详情参数
      if (localStorage.getItem('getPath')) {
        pathId = localStorage.getItem('getPath') + store.state.team.channel
      } else {
        pathId = store.state.team.channel + ',' + store.state.team.kind + ',' + store.state.team.channel
      }
      careId = store.state.team.quota
      businessId = store.state.team.kind
      break
    //  进入续收时
    case '05':
      if (store.state.ren.pageFlag === 1) {
        careTitle = '续收' + '-' + store.state.ren.kindName
        careDesc = '条件：' + store.state.ren.channelName + '-' + store.state.ren.quotaName
        carePath = '续收' + '-' + store.state.ren.kindName + '-' + store.state.ren.quotaName
        sharePath = '续收' + '-' + store.state.ren.kindName + '-' + store.state.ren.quotaName
      } else {
        if (localStorage.getItem('careDesc')) {
          careTitle = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          careDesc = '条件：' + store.state.ren.channelName + '-' + store.state.ren.timeName
          carePath = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          sharePath = '续收' + '-' + store.state.ren.kindName + '-' + store.state.ren.quotaName
        } else {
          careTitle = '续收' + '-' + store.state.ren.kindName + '-' + store.state.ren.quotaName
          careDesc = '条件：' + store.state.ren.channelName + '-' + store.state.ren.timeName
          carePath = '续收' + '-' + store.state.ren.kindName + '-' + store.state.ren.quotaName
          if (title === '续收') {
            sharePath = '续收' + '-' + store.state.ren.kindName + '-' + store.state.ren.quotaName
          } else {
            sharePath = '续收' + '-' + store.state.ren.kindName + '-' + store.state.ren.quotaName + '-' + title
          }
        }
      }
      //  判断关注详情参数
      if (localStorage.getItem('getPath')) {
        pathId = localStorage.getItem('getPath') + store.state.ren.channel
      } else {
        pathId = store.state.ren.kind + ',' + store.state.ren.channel
      }
      careId = store.state.ren.quota
      businessId = store.state.ren.kind
      break
    //  进入财务时
    case '06':
      if (store.state.fin.pageFlag === 1) {
        careTitle = '财务' + '-' + store.state.fin.kindName
        careDesc = '条件：' + store.state.fin.channelName + '-' + store.state.fin.quotaName
        carePath = '财务' + '-' + store.state.fin.kindName + '-' + store.state.fin.quotaName
        sharePath = '财务' + '-' + store.state.fin.kindName + '-' + store.state.fin.quotaName
      } else {
        if (localStorage.getItem('careDesc')) {
          careTitle = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          careDesc = '条件：' + store.state.fin.channelName + '-' + store.state.fin.timeName
          carePath = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          sharePath = '财务' + '-' + store.state.fin.kindName + '-' + store.state.fin.quotaName
        } else {
          careTitle = '财务' + '-' + store.state.fin.kindName + '-' + store.state.fin.quotaName
          careDesc = '条件：' + store.state.fin.channelName + '-' + store.state.fin.timeName
          carePath = '财务' + '-' + store.state.fin.kindName + '-' + store.state.fin.quotaName
          sharePath = '财务' + '-' + store.state.fin.kindName + '-' + store.state.fin.quotaName
          // if (title === '财务') {
          //   sharePath = '财务' + '-' + store.state.fin.kindName + '-' + store.state.fin.quotaName
          // } else {
          //   sharePath = '财务' + '-' + store.state.fin.quotaName + '-' + title
          // }
        }
      }
      //  判断关注详情参数
      if (localStorage.getItem('getPath')) {
        pathId = localStorage.getItem('getPath') + store.state.fin.channel
      } else {
        pathId = store.state.fin.kind + ',' + store.state.fin.channel
      }
      careId = store.state.fin.quota
      businessId = store.state.fin.kind
      break
    //  进入运营时
    case '07':
      if (store.state.ope.pageFlag === 1) {
        careTitle = '运营' + '-' + store.state.ope.kindName
        careDesc = '条件：' + store.state.ope.channelName + '-' + store.state.ope.quotaName
        carePath = '运营' + '-' + store.state.ope.kindName + '-' + store.state.ope.quotaName
        sharePath = '运营' + '-' + store.state.ope.kindName + '-' + store.state.ope.quotaName
      } else {
        if (localStorage.getItem('careDesc')) {
          careTitle = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          careDesc = '条件：' + store.state.ope.channelName + '-' + store.state.ope.timeName
          carePath = localStorage.getItem('getTitle') + '-' + localStorage.getItem('quotaname')
          sharePath = '运营' + '-' + store.state.ope.kindName + '-' + store.state.ope.quotaName
        } else {
          careTitle = '运营' + '-' + store.state.ope.kindName + '-' + store.state.ope.quotaName
          careDesc = '条件：' + store.state.ope.channelName + '-' + store.state.ope.timeName
          carePath = '运营' + '-' + store.state.ope.kindName + '-' + store.state.ope.quotaName
          if (title === '运营') {
            sharePath = '运营' + '-' + store.state.ope.kindName + '-' + store.state.ope.quotaName
          } else {
            sharePath = '运营' + '-' + store.state.ope.quotaName + '-' + title
          }
        }
      }
      //  判断关注详情参数
      if (localStorage.getItem('getPath')) {
        pathId = localStorage.getItem('getPath') + store.state.ope.channel
      } else {
        pathId = store.state.ope.kind + ',' + store.state.ope.channel
      }
      careId = store.state.ope.quota
      businessId = store.state.ope.kind
      break
    // 进入产品时
    case '08':
      if (store.state.pro.pageFlag === 1) {
        careTitle = '产品' + '-' + store.state.pro.typeName
        careDesc = '条件：' + store.state.pro.typeName + '-' + store.state.pro.quotaName
        carePath = '产品' + '-' + store.state.pro.typeName + '-' + store.state.pro.quotaName
        sharePath = '产品' + '-' + store.state.pro.typeName + '-' + store.state.pro.quotaName
      } else {
        if (localStorage.getItem('careDesc')) {
          careTitle = localStorage.getItem('getTitle') + '-' + localStorage.getItem('qoutaname')
          careDesc = '条件：' + store.state.pro.channelName + '-' + store.state.pro.timeName
          carePath = localStorage.getItem('getTitle') + '-' + localStorage.getItem('qoutaname')
          sharePath = '产品' + '-' + store.state.pro.typeName + '-' + store.state.pro.productName
        } else {
          careTitle = '产品' + '-' + store.state.pro.typeName + '-' + store.state.pro.quotaName
          careDesc = '条件：' + store.state.pro.channelName + '-' + store.state.pro.timeName
          carePath = '产品' + '-' + store.state.pro.typeName + '-' + store.state.pro.quotaName
          if (title === '产品') {
            sharePath = '产品' + '-' + store.state.pro.typeName + '-' + store.state.pro.productName
          } else {
            sharePath = '产品' + '-' + store.state.pro.typeName + '-' + store.state.pro.productName + '-' + title
          }
        }
      }
      //  判断关注详情参数
      if (localStorage.getItem('getPath')) {
        pathId = localStorage.getItem('getPath') + store.state.pro.channel
      } else {
        pathId = store.state.pro.kind + ',' + store.state.pro.channel
      }
      careId = store.state.pro.productCode
      businessId = store.state.pro.kind
      break
  }
  // // android终端
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  // // iOS终端
  // eslint-disable-next-line no-unused-vars
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  let postData = {
    'careId': careId, // 指标id
    'careTitle': careTitle, // 关注页面列表 title描述
    'careDesc': careDesc, // 关注页面列表 条件描述
    'careUrl': careUrl, // 关注页面路径
    'pathId': pathId, // 区分关注位置
    'moduleCode': modulesCode, // 关注模块的code
    'businessId': businessId, // 关注页面的类
    'title': title, // 关注页面的title
    'carePath': carePath, // 通知列表的描述信息
    'sharePath': sharePath
  }
  if (isAndroid) {
    // eslint-disable-next-line no-undef
    InquireCare.queryPageIsCare(careUrl, careId, careDesc, careTitle, pathId, businessId, title, carePath, sharePath)
  }
  // alert(postData.sharePath)
  return postData
}

// 获取当前月份的最后一天
export function getCurrentMonthLast (date) {
  var currentMonth = date.getMonth()
  var nextMonth = ++currentMonth
  var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
  var oneDay = 1000 * 60 * 60 * 24
  var lastTime = new Date(nextMonthFirstDay - oneDay)
  var month = parseInt(lastTime.getMonth() + 1)
  var day = lastTime.getDate()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '' + month + '' + day
}

// 获取年月日
export function getCurrentTime (date) {
  var nowMonth = date.getMonth() + 1
  var strDate = date.getDate()
  if (nowMonth >= 1 && nowMonth <= 9) {
    nowMonth = '0' + nowMonth
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  return date.getFullYear() + '' + nowMonth + '' + strDate
}

// 获取最大日期
export function maxTime () {
  let max = new Date()
  // max.setTime(max.getTime() - 24 * 60 * 60 * 1000)
  return max
}

// 获取最小日期
// export function minTime () {
//   let min = new Date()
//   min.setFullYear(min.getFullYear() - 2)
//   return min
// }

// 当点击日的时候显示最小日期,往前30天
// export function DayminTime () {
//   let min = new Date()
//   min.setDate(min.getDate() - 30)
//   return min
// }

/* 当年一月 */
export function thisYearJMonth () {
  var date = new Date()
  var year = date.getFullYear()
  let min = new Date(year, 0, 1)
  return min
}

/* 当年一月一号 */
export function thisYearDayMonth () {
  var date = new Date()
  var year = date.getFullYear()
  let min = new Date(year, 0, 1)
  return min
}

/* 5年一月 */
export function fiveYearJMonth () {
  var date = new Date()
  var year = date.getFullYear() - 4
  let min = new Date(year, 0, 1)
  return min
}

/* 当年上月 */
export function thisYearLMonth () {
  var date = new Date()
  var year = date.getFullYear()
  var month = date.getMonth() - 1
  let max = new Date(year, month, 1)
  return max
}

/* 当年昨天 */
export function yesterday () {
  var date = new Date()
  var oneDay = 1000 * 60 * 60 * 24
  var lastTime = new Date(date - oneDay)
  var year = lastTime.getFullYear()
  var month = lastTime.getMonth()
  var day = lastTime.getDate()
  let max = new Date(year, month, day)
  return max
}

/* 昨天所在月 */
export function yesterdayForMonth () {
  var date = new Date()
  var oneDay = 1000 * 60 * 60 * 24
  var lastTime = new Date(date - oneDay)
  var year = lastTime.getFullYear()
  var month = lastTime.getMonth()
  var day = lastTime.getDate()
  let max = new Date(year, month, day)
  return max
}

/* 昨天所在年一月 */
export function yesterdayForYear () {
  var date = new Date()
  var oneDay = 1000 * 60 * 60 * 24
  var lastTime = new Date(date - oneDay)
  var year = lastTime.getFullYear()
  let max = new Date(year, 0, 1)
  return max
}

/* 2019/11/9 @author mengxl */
// 获取当前时间
// var date = new Date();
// var year = date.getFullYear(); //年
// var month = date.getMonth() + 1; //月
// var day = date.getDate(); //日
// if (month < 10) {
//     month = "0" + month;
// }
// if (day < 10) {
//     day = "0" + day;
// }
// var nowDate = year + "-" + month + "-" + day;

// 当点击日的时候显示最小日期2019年1月1日
export function DayminTime () {
  let min = new Date('2019/01/01')
  return min
}

export function minTime () {
  let min = new Date('2016/01/01')
  return min
}

// 获取 安卓ios url参数
export function getUrlKey (name, url) {
  // eslint-disable-next-line no-sparse-arrays
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ''])[1].replace(/\+/g, '%20')) || null
}

// 容错处理。请求报表之前，当isBatchFinish为true时，实时数据跑完，当为false时，再查询一次查询是否跑完
export function promiseIsBatchFinish (resolve, reject) {
  resolve(true)
  // if (store.state.smartbi.isBatchFinish) {
  //   resolve(true)
  // } else {
  //   var getFlag = getAction('/simpapp/isBatchFinish/dataBatch')
  //   getFlag.then(res => {
  //     var isBatchFinish = res.data
  //     console.log('isBatchFinish为：', isBatchFinish)
  //   store.commit('SMARTBI_IS_BATCH_FINISH', isBatchFinish)
  //   // resolve(isBatchFinish)
  //   if (isBatchFinish) {
  //     resolve(true)
  //   } else {
  //     resolve(false)
  //   }
  // })
  // }
}

export function sortArrId (arr) {
  for (let j = 0; j < arr.length; j++) {
    for (let i = 0; i < arr.length - 1 - j; i++) {
      if (arr[i].id > arr[i + 1].id) {
        [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
      }
    }
  }
  return arr
}

export function sortArrProvincecomCode (arr) {
  for (let j = 0; j < arr.length; j++) {
    for (let i = 0; i < arr.length - 1 - j; i++) {
      if (arr[i].provincecomCode > arr[i + 1].provincecomCode) {
        [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
      }
    }
  }
  return arr
}

export function sortArrRank (arr) {
  for (let j = 0; j < arr.length; j++) {
    for (let i = 0; i < arr.length - 1 - j; i++) {
      if (arr[i].rank > arr[i + 1].rank) {
        [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
      }
    }
  }
  return arr
}

// 存储当前用户sessionStorage
export function handleUserSessionStorage () {
  // 暂存当前登录用户的sessionStorage
  let data = {
    userId: sessionStorage.getItem('userId'),
    token: sessionStorage.getItem('token'),
    pageCode: sessionStorage.getItem('pageCode'),
    leaderFlag: sessionStorage.getItem('leaderFlag'),
    account: sessionStorage.getItem('account'),
    areaCode: sessionStorage.getItem('areaCode'),
    areaFlag: sessionStorage.getItem('areaFlag'),
    level: sessionStorage.getItem('level'),
    orgId: sessionStorage.getItem('orgId'),
    moduleInfo: sessionStorage.getItem('moduleInfo')
  }
  // sessionStorage.setItem(sessionStorage.userId, JSON.stringify(data))
  let queryTm = getUrlKey('tm', window.location.href)
  sessionStorage.setItem(queryTm, JSON.stringify(data))
}

// 重置用户sessionStorage
export function resetUserSessionStorage (queryTm) {
         // console.log('queryToken', queryToken)
         // if (sessionStorage.getItem(queryToken)) {
         //   let prevUserInfo = JSON.parse(sessionStorage.getItem(queryToken))
         if (sessionStorage.getItem(queryTm)) {
           let prevUserInfo = JSON.parse(sessionStorage.getItem(queryTm))

           // 替换用户信息
           setUserId(prevUserInfo.userId)
           setToken(prevUserInfo.token)
           store.commit('SET_TOKEN', prevUserInfo.token)
           setUserPageCode(prevUserInfo.pageCode)
           store.commit('USER_SET_PAGE_CODE', prevUserInfo.pageCode)
           setLeaderFlag(prevUserInfo.leaderFlag)
           store.commit('SET_LEADER_FLAG', prevUserInfo.leaderFlag)
           setUserAccount(prevUserInfo.account)
           store.commit('USER_SET_ACCOUNT', prevUserInfo.account)
           setUserAreaCode(prevUserInfo.areaCode)
           store.commit('USER_SET_AREA_CODE', prevUserInfo.areaCode)
           setUserAreaFlag(prevUserInfo.areaFlag)
           store.commit('USER_SET_AREA_FLAG', prevUserInfo.areaFlag)
           setUserLevel(prevUserInfo.level)
           store.commit('USER_SET_LEVEL', prevUserInfo.level)
           setUserOrg(prevUserInfo.orgId)
           store.commit('USER_SET_ORG', prevUserInfo.orgId)
           setModuleInfo(prevUserInfo.moduleInfo)
           store.commit('SET_MODULE_INFO', JSON.parse(prevUserInfo.moduleInfo))
           // 替换完成后清除暂存的prevUserInfo
           sessionStorage.removeItem(queryTm)
         }
       }



// WEBPACK FOOTER //
// ./src/utils/util.js